import React from 'react';
import {
	GuildAuth0Domain,
	MemberExperienceAuthProvider,
	useMemberExperienceAuth,
} from '@guildeducationinc/auth-frontend-tools';
import { AnalyticsDelayWrapper } from '@guildeducationinc/mfe-utils';
import { GUILD_DOMAIN, AUTH0_DOMAIN, AUTH0_CLIENT_ID } from 'src/utilities/envConfig';
import { getUpdatedURL } from 'src/utilities/urlUtility';
import { ErrorPage, Loading } from '@guildeducationinc/recess';

const AuthLoaderAndErrorHandler: React.FC = ({ children }) => {
	const { authError, isLoading, logout } = useMemberExperienceAuth();

	if (authError) {
		return <ErrorPage goBack={logout} message={authError.message} />;
	}

	if (isLoading) {
		return <Loading label='catalog' />;
	}

	return <>{children}</>;
};

export const AuthProviderWrapper: React.FC = ({ children }) => {
	const updatedSubdomainUrl = getUpdatedURL();

	if (updatedSubdomainUrl) {
		window.location.href = updatedSubdomainUrl;
		return null;
	}

	return (
		<AnalyticsDelayWrapper>
			<MemberExperienceAuthProvider
				clientId={AUTH0_CLIENT_ID}
				collectBasicInfoUrl={`https://profile.${GUILD_DOMAIN}`}
				domain={AUTH0_DOMAIN as GuildAuth0Domain}
				forceRedirectForBasicInfoMissing={true}
				verifyUrl={`https://verify.${GUILD_DOMAIN}`}
			>
				<AuthLoaderAndErrorHandler>{children}</AuthLoaderAndErrorHandler>
			</MemberExperienceAuthProvider>
		</AnalyticsDelayWrapper>
	);
};
